import { ServiceData } from '@/types';

import articles from './PILATES_ARTICLES_DK.json';
import exercises from './PILATES_EXERCISES_DK.json';
import recipes from './PILATES_RECIPES_DK.json';

export const PILATES_DATA_DK: ServiceData = {
  articles,
  exercises,
  recipes,
};
